<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

import MondialLogo from '@/components/MondialLogo';

export default {
  name: 'LoginUser',
  components: {
    MondialLogo,
  },
  computed: {
    ...mapState('user', [
      'user',
      'errors',
    ]),
    ...mapGetters('user', [
      'isLoggedIn',
    ]),
    email: {
        get() {
          return this.user.email || null;
        },
        set(value) {
          const { user } = this;
          user.email = value;
          this.setUser(user)
        },
    },
    password: {
        get() {
          return this.user.password || null;
        },
        set(value) {
          const { user } = this;
          user.password = value;
          this.setUser(user)
        },
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchLogin',
    ]),
    ...mapMutations('user', [
      'setUser',
    ]),
    login() {
      this.fetchLogin()
        .then(() => {
          if (this.isLoggedIn) {
            this.$router.push({ name: 'home' });
          }
        })
    },
  }
};
</script>
<style lang="scss" scoped>
    .footer-links a {
        font-size:120%;
    }
</style>
<template>
    <div id="loginWrapper" class="pb-5 bg-white">
        <div class="bg-white pt-5 pb-5 text-center">
            <h1>Zadbaj o swoje zdrowie już dziś</h1>
            <h5 class="font-weight-normal">Skorzystaj ze szkoleń on-line i dowiedz się jak żyć zdrowo.</h5>
        </div>
        <div id="login" class="text-center">
            <div class="wrapper text-left">
                <div class="container d-flex flex-column">
                    <h2>Formularz logowania</h2>

                    <div class="d-flex justify-content-center mt-3 mb-3 footer-links">
                        <router-link :to="{ name: 'register' }" class="mr-3">
                            Zarejestruj się
                        </router-link>
                        |
                        <router-link :to="{ name: 'forgotPassword' }" class="ml-3">
                            Zapomniałeś hasła
                        </router-link>
                    </div>

                    <label for="email">Email</label>
                    <input id="email" class="mb-3" v-model="email" />

                    <label for="password">Hasła</label>
                    <input id="password" v-model="password" />

                    <div class="errors" v-if="errors.length > 0">
                        <div v-for="error in errors">{{ error }}</div>
                    </div>
                    <div class="text-center">
                        <button @click="login">
                            Zaloguj
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <MondialLogo />
    </div>
</template>
